import { render } from "./MiniLoading.vue?vue&type=template&id=e87deade&scoped=true"
const script = {}

import "./MiniLoading.vue?vue&type=style&index=0&id=e87deade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87deade"]])

export default __exports__